import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import SectionToggle from "../../components/sectionToggle/sectionToggle";
import { actionCreators } from "./redux/BrandLeaderBoardSagas";
import DatePicker from "./smartComponents/datePicker";
import FilterByView from "./smartComponents/filterByView";
import LoadingAnimation from "../../components/loadingAnimation/loadingAnimation";
import MetricsCards from "./smartComponents/metricsCards";
import { DataPoints } from "./smartComponents/dataPoint";
import "./brandLeaderBoard.css.scss";
import MetricsFilter from "./smartComponents/metricsFilter";
import RankTable from "./smartComponents/rankTable";

const BrandLeaderBoardModule = ({ params }) => {
  const dispatch = useDispatch();
  const {
    isLoading,
    filtersDirty,
    cardsData,
    currentUser: { displayViewDropdown }
  } = useSelector((state) => state.BrandLeaderBoard);
  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const renderUpdateBtn = () => {
    if (filtersDirty && !isLoading) {
      return (
        <div className="action-buttons">
          <button className="submit" onClick={() => dispatch(actionCreators.updateTableData())}>
            Update
          </button>
          <button className="submit reset" onClick={() => dispatch(actionCreators.resetFilters())}>
            Reset
          </button>
        </div>
      );
    }

    return null;
  };

  const updateButtons = renderUpdateBtn();

  const getContent = () => (
    <>
      <div id="override-edit-selection-bar" className="edit-selections-bar">
        <div className="filters-wrapper">
          {displayViewDropdown ? (
            <div className="view-select-box">
              <p>View</p>
              <FilterByView />
            </div>
          ) : null}

          <div className="date-select-box monthly">
            <p>Metrics</p>
            <MetricsFilter />
          </div>

          <div className="date-select-box monthly">
            <p>Date</p>
            <DatePicker />
          </div>
          {updateButtons}
        </div>
      </div>
      {!isLoading ? (
        cardsData?.all_data?.length ? (
          <>
            <div className="rank-data-container">
              <DataPoints />
              <RankTable />
            </div>
            <MetricsCards />
          </>
        ) : (
          <p className="error">No data available</p>
        )
      ) : (
        <LoadingAnimation text="Loading data" />
      )}
    </>
  );

  return (
    <div id="brandLeaderBoardModule-root">
      <SectionToggle title="Brand Leaderboard" content={getContent()} learnMore={<></>} />
    </div>
  );
};
export default BrandLeaderBoardModule;

BrandLeaderBoardModule.propTypes = {
  params: PropTypes.object
};
